import { queryParam, user } from "../../hooks/use-registered-metadata";
import { ProductKey } from "../../models";

import { PROVISIONING, ScreenConfig, TEAM_CHOICE } from "./utils";

export const defaultScreenConfig: ScreenConfig = {
    [TEAM_CHOICE]: {
        position: { default: 100 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: user.isN2n,
                            value: true
                        },
                        {
                            key: queryParam.templateId,
                            value: undefined
                        },
                        {
                            key: queryParam.products,
                            value: [ProductKey.JIRA_SERVICE_MANAGEMENT]
                        }
                    ]
                },
                {
                    conditionalAND: [
                        {
                            key: user.isExistingJsmUser,
                            value: false
                        },
                        {
                            key: queryParam.templateId,
                            value: undefined
                        },
                        {
                            key: queryParam.products,
                            value: [ProductKey.JIRA_SERVICE_MANAGEMENT]
                        }
                    ]
                }
            ]
        }
    },
    [PROVISIONING]: {
        position: { default: 400 },
        onMount: () => undefined,
        visibility: {
            default: true
        }
    }
};
